module.exports = __webpack_public_path__ + "img/app-91sm.820310ce.webp";